export default __webpack_public_path__ + "static/media/dev_stack.41049451.svg";